<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Ticket Created Message</ion-title>
        <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list lines="none">
        <ion-item color="secondary">
            Welcome the ticket holder.
        </ion-item>

        <app-customer-messages 
            [config]="config" 
            [(data)]="vm" 
            [submitted]="submitted"
            (save)="onSaveClick()">
        </app-customer-messages>
    </ion-list> 
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSaveClick()" [disabled]="customerMessagesComponent?.form?.invalid"
            data-test="saveButton">Save</ion-button>
    </ion-toolbar>
</ion-footer>